import type { AppLocale } from './types';

export { antdLocales } from './antdLocales';

const loaders = {
  'bn-BD': () => import('virtual:app-locale/bn-BD'),
  'en-US': () => import('virtual:app-locale/en-US'),
  'fa-IR': () => import('virtual:app-locale/fa-IR'),
  'id-ID': () => import('virtual:app-locale/id-ID'),
  'ja-JP': () => import('virtual:app-locale/ja-JP'),
  'pt-BR': () => import('virtual:app-locale/pt-BR'),
  'zh-CN': () => import('virtual:app-locale/zh-CN'),
  'zh-TW': () => import('virtual:app-locale/zh-TW'),
};

const catalogs: Partial<Record<AppLocale, Record<string, string>>> = {};
const pending = new Map<AppLocale, Promise<void>>();

export function isLocaleLoaded(locale: AppLocale) {
  return Boolean(catalogs[locale]);
}

export function getLocaleMessages(locale: AppLocale) {
  const messages = catalogs[locale];
  if (!messages) throw new Error(`Locale not loaded: ${locale}`);
  return messages;
}

export function loadLocale(locale: AppLocale): Promise<void> {
  if (catalogs[locale]) return Promise.resolve();
  const existing = pending.get(locale);
  if (existing) return existing;
  const request = loaders[locale]()
    .then(({ default: messages }) => {
      catalogs[locale] = messages;
    })
    .finally(() => pending.delete(locale));
  pending.set(locale, request);
  return request;
}
